var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#098E1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.9962C23.5914 10.9962 26.5027 13.9076 26.5027 17.4989C26.5027 21.0903 23.5914 24.0016 20 24.0016C16.4087 24.0016 13.4973 21.0903 13.4973 17.4989C13.4973 13.9076 16.4087 10.9962 20 10.9962",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 24.0017H25.0022",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 15.0218V14.1961",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 19.9763V20.802",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5682 19.3866C18.7804 19.7488 19.1674 19.9727 19.5872 19.9762H20.4955C21.0903 19.991 21.5992 19.5521 21.6718 18.9615C21.7444 18.371 21.3569 17.8219 20.7763 17.6922L19.2288 17.3033C18.655 17.1689 18.2741 16.6242 18.3449 16.039C18.4156 15.4539 18.9152 15.0156 19.5046 15.0218H20.4129C20.8331 15.0246 21.2206 15.2487 21.4327 15.6114",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0035 20H27.003C28.108 20 29.0038 20.8958 29.0038 22.0008V27.0029C29.0038 28.1079 28.108 29.0037 27.003 29.0037H12.9972C11.8921 29.0037 10.9963 28.1079 10.9963 27.0029V22.0008C10.9963 20.8958 11.8921 20 12.9972 20H13.9967",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.27b06b0fe74adc6e576a161e1cdd16f9.svg";
export { ForwardRef as ReactComponent };